export default __webpack_public_path__ + "external-links-en-au-ConsultUK.json";